import { useNavigate } from "react-router-dom";

import './MenuLink.scss';

export const MenuLink = ({Icon, link, title, chipTitle, show, active = false, onNavigate}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (!active) return;

        if (link.startsWith("http")) {
            window.open(link, "_blank");
        } else {
            navigate(link);
            if (onNavigate) {
                onNavigate();
            }
        }
    };
 
    return (
        <div className={`menu-link ${!show ? "--hide" : ""} ${active ? "--active" : ""}`} onClick={handleClick}>
            <div className={"menu-link_container"}>
                <div className={"menu-link_title"}>
                    {Icon && <Icon style={{fontSize: "18px"}}/>}
                    {title}
                </div>
                {chipTitle && (
                    <div className={"menu-link_chip"}>
                        {chipTitle}
                    </div>
                )}
            </div>
        </div>
    )
}